/**
 * Strip HTML tags and decode common entities to plain text, then trim and slice.
 * @param {string} html - Raw HTML string
 * @param {number} [maxLength=500] - Max length of the result
 * @returns {string}
 */
export function stripHtmlToPlainText(html, maxLength = 500) {
  if (!html || typeof html !== 'string') return ''
  return html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .trim()
    .slice(0, maxLength)
}

/**
 * Build resourceData for meta/AI generation. Strips descriptionHtml to plain text inside.
 * @param {string} type - Resource type (e.g. 'attrazione', 'evento')
 * @param {Record<string, string>} titles - Titles by language
 * @param {string} [descriptionHtml] - Raw HTML string (will be stripped to plain text)
 * @param {number} [excerptMaxLength=500]
 * @returns {{ type: string, titles: Record<string, string>, descriptionExcerpt: string }}
 */
export function buildResourceData(type, titles, descriptionHtml, excerptMaxLength = 500) {
  const html = descriptionHtml != null && typeof descriptionHtml === 'string' ? descriptionHtml : ''
  return {
    type,
    titles: titles || {},
    descriptionExcerpt: stripHtmlToPlainText(html, excerptMaxLength),
  }
}
